let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: "电站ID",
    props: "stationNo",
    minWidth: 180
  },
  {
    label: "电站名称",
    props: "stationName",
    minWidth: 180,
    tooltip: true
  },
  {
    label: "ZD-BOX数量",
    props: "zdBoxCount",
    minWidth: 180,
    tooltip: true
  },
  {
    label: "电池月放电量",
    props: "monthlyDischargePower",
    minWidth: 180,
    tooltip: true
  },
  {
    label: "车辆月放电量",
    props: "monthlyVehicleDischargePower",
    minWidth: 180,
    tooltip: true
  },
  {
    label: "充电桩数量",
    props: "totalPileCount",
    minWidth: 100
  },
  // {
  //     label: '异常桩数量',
  //     props: 'errorPileCount',
  //     minWidth: 100,
  // },
  {
    label: "离线桩数量",
    props: "outLinePileCount",
    minWidth: 100,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.outLinePileCount) {
        return row.outLinePileCount;
      } else {
        return "0";
      }
    }
  },
  {
    label: `离线桩比例%`,
    props: "offRate",
    minWidth: 130,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.offRate) {
        return row.offRate + "%";
      } else {
        return "0";
      }
    }
  },
  {
    label: "故障桩数量",
    props: "faultPileCount",
    minWidth: 100,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.faultPileCount) {
        return row.faultPileCount;
      } else {
        return "0";
      }
    }
  },
  {
    label: "充电量",
    props: "totalChargeCount",
    minWidth: 120,
    sortable: true
  },
  {
    label: "本月充电量",
    props: "currMonChargeCount",
    minWidth: 140,
    sortable: true
  },
  {
    label: "电站状态",
    props: "stationOperateType",
    minWidth: 100,
    formatter: function formatter(row, column, cellValue, index) {
      if (row.stationOperateType == "N") {
        return "使用中";
      } else if (row.stationOperateType == "Y") {
        return "作废";
      } else {
        return "";
      }
    }
  },

  {
    label: "电站地址",
    props: "stationAddr",
    minWidth: 180,
    tooltip: true
  },

  {
    label: "资费（元）",
    props: "ttlVal",
    minWidth: 100,
    formatter: function formatter(row, column, cellValue, index) {
      // 做判断
      if (row.ttlVal) {
        return row.ttlVal;
      } else {
        return "0";
      }
    }
  },
  {
    label: "运营状态",
    props: "stationStatusName",
    minWidth: 120
  },

  {
    label: "运营商名称",
    props: "dealName",
    minWidth: 200
  },
  {
    label: "运营类别",
    props: "isHostOperate",
    minWidth: 100,
    formatter: function formatter(row, column, cellValue, index) {
      if (row.isHostOperate == "01") {
        return "代运营";
      } else if (row.isHostOperate == "02") {
        return "自运营";
      } else {
        return "";
      }
    }
  }
];

// // 面包屑
pageConfig.listBreadCrumb = [
  {
    type: "title",
    name: "首页"
  },
  {
    type: "title",
    name: "充电管理"
  },
  {
    type: "title",
    name: "电站管理"
  }
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: true,
  showIndex: true
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100]
};

// 列表-分页参数
pageConfig.dialogPagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100]
};
// 列表-编辑操作
pageConfig.tableEditObj = {
  editKey: "id",
  editRouter: "pileStationDetail"
};

// 路由
pageConfig.listRouter = "pileStationList";

//详情
pageConfig.reportDetailRouter = "reportDetail";

pageConfig.postageDetailRouter = "postageDetail";

pageConfig.pileListRouter = "pileList";

pageConfig.orderListRouter = "orderManageList";

pageConfig.settlementDetailRouter = "settlementDetail";

pageConfig.Distribution = "Distribution";

pageConfig.contract = "contract";

pageConfig.meter = "meter";

pageConfig.seat = "seatFee"; // 占位费

pageConfig.energyStorage ='energyStorageDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [
  {
    type: "title",
    name: "首页"
  },
  {
    type: "title",
    name: "充电管理"
  },
  {
    type: "router",
    name: "电站管理",
    router: "pileStationList"
  },
  {
    type: "title",
    name: "电站详情"
  }
];

// 占位费 面包屑
pageConfig.seatBreadCrumb = [
  {
    type: "title",
    name: "首页"
  },
  {
    type: "title",
    name: "充电管理"
  },
  {
    type: "router",
    name: "电站管理",
    router: "pileStationList"
  },
  {
    type: "title",
    name: "占位费设置"
  }
];

// 储能策略
pageConfig.zdBoxBreadCrumb = [
  {
    type: "title",
    name: "首页"
  },
  {
    type: "title",
    name: "充电管理"
  },
  {
    type: "router",
    name: "电站管理",
    router: "pileStationList"
  },
  {
    type: "title",
    name: "储能充放策略"
  }
];

pageConfig.formRules = {
  stationName: [{ required: true, message: "请输入电站名称", trigger: "blur" }],
  stationAddr: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
  parkRate: [{ required: true, message: "请选择停车费", trigger: "change" }],
  stationDesc: [{ required: true, message: "请输入站点说明", trigger: "blur" }],
  portType: [{ required: true, message: "请输入停车场类型", trigger: "blur" }],
  stationStatus: [
    { required: true, message: "请选择运营状态", trigger: "blur" }
  ]
};
pageConfig.contractRules = {
  contractBeginTime: [
    { required: true, message: "请选择签约时间", trigger: "change" }
  ],
  contractEndTime: [
    { required: true, message: "请选择到期时间", trigger: "change" }
  ],
  settlementCycle: [
    { required: true, message: "请选择结算周期", trigger: "change" }
  ],
  contactsName: [{ required: true, message: "请输入联系人", trigger: "blur" }],
  profitSettleRatio: [
    { required: true, message: "请输入分润比例", trigger: "blur" }
  ],
  nextSettlementTime: [
    { required: true, message: "请选择下次结算日期", trigger: "change" }
  ],
  contactsTel: [
    { required: true, message: "请输入联系电话", trigger: "blur" },
    {
      pattern: /^1\d{10}$|^(0\d{2,3}-?|\(0\d{2,3}\))?[1-9]\d{4,7}(-\d{1,8})?$/,
      message: "请输入正确的联系电话",
      trigger: "blur"
    }
  ]
};

// 占位费 验证
pageConfig.seatFormRules = {
  basicFee: [
    { required: true, message: "请输入基础费用", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        let reg = /^([0-9]*)+(\.[0-9]{1,2})?$/;
        if (reg.test(parseFloat(value))) {
          if (parseFloat(value) < 0.01) {
            callback(new Error("输入范围 0.01~10.00，请重新键入"));
          }
          if (parseFloat(value) > 10.0) {
            callback(new Error("输入范围 0.01~10.00，请重新键入"));
          }
        } else {
          if (parseFloat(value).toString() == "NaN") {
            callback(new Error("请输入数字"));
          }
          if (value.length > 4) {
            callback(new Error("请保留两位小数"));
          }
        }
      },
      trigger: "blur"
    }
  ],
  freeRate: [
    { required: true, message: "请输入空闲率标准", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (!/^([1-9][0-9]*)+(\.[0-9]{1,2})?$/.test(parseInt(value))) {
          if (parseFloat(value).toString() == "NaN") {
            callback(new Error("请输入数字"));
          }
          callback(new Error("输入范围 10~100，请重新键入"));
        } else {
          if (parseFloat(value) < 10) {
            callback(new Error("输入范围 10~100，请重新键入"));
          }
          if (parseFloat(value) > 100) {
            callback(new Error("输入范围 10~100，请重新键入"));
          }
        }
      },
      trigger: "blur"
    }
  ],
  freeTime: [
    { required: true, message: "请选择占位免计时间", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (parseInt(value) == 0) {
          callback();
        }
        if (/^-[1-9]\d*$/.test(value)) {
          callback(new Error("请输入大于等于0的正整数"));
        }
      },
      trigger: "blur"
    }
  ],
  bufferTime: [
    { required: true, message: "请输入计费缓冲时间", trigger: "blur" },
    {
      validator: (rule, value, callback) => {
        if (parseInt(value) == 0) {
          callback();
        }
        if (/^-[1-9]\d*$/.test(value)) {
          callback(new Error("请输入大于等于0的正整数"));
        }
      },
      trigger: "blur"
    }
  ],
  maxFeeStatus: [
    { required: true, message: "请选择每日最高上限", trigger: "change" }
  ],
  maxFee: [
    {
      validator: (rule, value, callback) => {
        if (parseInt(value) == 0) {
          callback();
        }
        if (/^-[1-9]\d*$/.test(value)) {
          callback(new Error("请输入大于等于 0 的整数数字"));
        }
      },
      trigger: "blur"
    }
  ]
};

export default pageConfig;
